module.exports = __webpack_public_path__ + "img/cloud-network.918f64c.svg";